import { cn } from '../../utils'
import { getSizeClasses, getVariantClasses } from './Text.styles'
import { TextProps } from './Text.types'

export const Text = ({
    text,
    color = 'light',
    className,
    variant = 'text',
    size = 'sm',
}: TextProps) => {
    const classes = cn(
        getVariantClasses(color, variant),
        getSizeClasses(size),
        className
    )
    return (
        <p className={cn(classes)} color={color}>
            {text}
        </p>
    )
}
